import { post } from '@/utils/network';

//老师端获取PPT列表
export const getAllSlides = (params: { interactid: string;}) => {
    return post('/InteractPPTApi/getAllSlides', params)
}